import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Button from '../../../../Button';
import Popup from '../../../../common/Popup';
import Loader from '../../../../common/Loader';

import { selectInsuranceIsDeleting } from '../../../../../redux/manage-insurances/selectors/delete-patient-insurance';

import styles from './index.styl';

const DeleteAdditionalInsuranceConfirmationModal = ({ onClose, onDelete }) => {
  const { formatMessage } = useIntl();

  const loading = useSelector(selectInsuranceIsDeleting);

  const title = formatMessage({ id: 'paperwork.modal.confirmDeleteInsurance' });

  const subtitle = formatMessage({
    id: 'paperwork.modal.deleteInsuranceWarning',
  });

  const deleteButtonTitle = formatMessage({
    id: 'common.deleteInsurance',
  });

  const cancelButtonTitle = formatMessage({
    id: 'common.cancel',
  });

  return (
    <Popup opened withHeading={false} mobileFullScreen={false}>
      <section className={styles.content}>
        <div className={styles.title}>{title}</div>

        {subtitle}

        <div className={styles.buttonWrapper}>
          <Button color="primary" onClick={onDelete} type="button" raised>
            {loading ? <Loader className={styles.loader} /> : deleteButtonTitle}
          </Button>
          <Button
            color="accent"
            raised
            type="button"
            onClick={onClose}
            children={cancelButtonTitle}
          />
        </div>
      </section>
    </Popup>
  );
};

DeleteAdditionalInsuranceConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteAdditionalInsuranceConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/DeleteAdditionalInsuranceConfirmationModal/index.jsx